module.exports = __webpack_public_path__ + "assets/img/ppt.e1561f53.svg";